var _circle, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#66A3FF"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "url(#paint0_radial)",
    style: {
      mixBlendMode: "darken"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.0487 76.6957C60.4411 76.6957 59.8335 76.4805 59.3525 76.0248C57.0613 73.8856 53.9347 72.6324 50.5297 72.5058C46.7575 72.3539 43.1879 73.6324 40.7069 75.9995C39.7069 76.9489 38.1373 76.9109 37.1879 75.9235C36.2385 74.9235 36.2765 73.3539 37.2765 72.4046C40.7322 69.1134 45.6309 67.3413 50.7195 67.5311C55.3018 67.7084 59.5803 69.4299 62.7449 72.3792C63.7449 73.316 63.8082 74.8982 62.8715 75.8982C62.3778 76.4299 61.7196 76.6957 61.0487 76.6957Z",
    fill: "#030822"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4721 32.6958C18.0417 32.6958 17.5987 32.5186 17.2949 32.1515C16.7379 31.5059 16.8139 30.5312 17.4721 29.9743C21.0037 26.9363 25.5101 25.0376 30.143 24.6198C31.0037 24.5565 31.7379 25.1768 31.8265 26.0249C31.9025 26.873 31.2696 27.6198 30.4215 27.7084C26.4215 28.0629 22.5227 29.7084 19.4721 32.3287C19.181 32.5819 18.8265 32.6958 18.4721 32.6958Z",
    fill: "#030822"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5725 32.6959C81.2181 32.6959 80.8636 32.5693 80.5725 32.3288C77.5219 29.7085 73.6231 28.0756 69.6231 27.7085C68.775 27.6326 68.1421 26.8857 68.2181 26.025C68.294 25.1769 69.0409 24.5693 69.9016 24.6199C74.5345 25.0376 79.0408 26.9364 82.5851 29.9743C83.2307 30.5313 83.3067 31.506 82.7497 32.1516C82.4459 32.5186 82.0029 32.6959 81.5725 32.6959Z",
    fill: "#030822"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5519 47.0504C78.5519 49.8732 76.3367 52.1643 73.6152 52.1643C70.881 52.1643 68.6659 49.8732 68.6659 47.0504C68.6659 44.2276 70.881 41.9365 73.6152 41.9365C76.3494 41.9365 78.5519 44.2276 78.5519 47.0504Z",
    fill: "#030822"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3985 47.0502C32.3985 49.873 30.1833 52.1642 27.4618 52.1642C24.7276 52.1642 22.5124 49.873 22.5124 47.0502C22.5124 44.2275 24.7276 41.9363 27.4618 41.9363C30.1833 41.9363 32.3985 44.2275 32.3985 47.0502Z",
    fill: "#030822"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.25 40.7692) rotate(96.0235) scale(59.5596 59.5396)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.854067,
    stopColor: "#FFBB54",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#FFDA54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854267,
    stopColor: "#FFBB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854367,
    stopColor: "#17A6ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854467,
    stopColor: "#1786ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBad);
export default __webpack_public_path__ + "static/media/Bad.8ce8fb2a9628c35d84517e12ff38f519.svg";
export { ForwardRef as ReactComponent };